<template>
  <section class="section-container">
    <div class="content-wrapper">

      <div class="content-heading" v-if="user.id">
      {{ $t('supplieruser.edit-employee') }}
      </div>

      <div class="content-heading" v-else>
        {{ $t('supplieruser.add-employee') }}
      </div>

      <div class="row">
        <div class="col-xl-4">
          <div class="card card-default">
            <div class="card-body">
              <form @submit.prevent="save" class="form-modal user">

                <div class="form-group">
                  <label for="first_name">{{ $t('supplieruser.firstname') }} *</label>
                  <input
                    :class="{'parsley-error': errors.first_name}"
                    autocomplete="off"
                    class="form-control"
                    id="first_name"
                    :placeholder="$t('supplieruser.insert-firstname')"
                    type="text"
                    v-model="user.first_name">
                  <ul class="parsley-errors-list filled" v-if="errors.first_name">
                    <li class="parsley-required">{{ errors.first_name[0] }}</li>
                  </ul>
                </div>

                <div class="form-group">
                  <label for="last_name">{{ $t('supplieruser.last-name') }} *</label>
                  <input
                     :class="{'parsley-error': errors.surname}"
                     autocomplete="off"
                     class="form-control"
                     id="last_name"
                     :placeholder="$t('supplieruser.insert-surname')"
                     type="text"
                     v-model="user.last_name">
                  <ul class="parsley-errors-list filled" v-if="errors.last_name">
                    <li class="parsley-required">{{ errors.last_name[0] }}</li>
                  </ul>
                </div>

                <div class="form-group">
                  <label for="email">{{ $t('supplieruser.email') }} *</label>
                  <input
                    :class="{'parsley-error': errors.email}"
                    autocomplete="off"
                    class="form-control"
                    id="email"
                    :placeholder="$t('supplieruser.insert-email')"
                    type="text"
                    v-model="user.email">
                  <ul class="parsley-errors-list filled" v-if="errors.email">
                    <li class="parsley-required">{{ errors.email[0] }}</li>
                  </ul>
                </div>

                <div class="form-group">
                  <label for="personal_code">{{ $t('supplieruser.personalcode') }}</label>
                  <input
                    :class="{'parsley-error': errors.personal_code}"
                    autocomplete="off"
                    class="form-control"
                    id="personal_code"
                    :placeholder="$t('supplieruser.insert-personalcode')"
                    type="text"
                    v-model="user.personal_code">
                  <ul class="parsley-errors-list filled" v-if="errors.personal_code">
                    <li class="parsley-required">{{ errors.personal_code[0] }}</li>
                  </ul>
                </div>

                <div class="form-group">
                  <label for="phone">{{ $t('supplieruser.phone') }} *</label>
                  <input
                    :class="{'parsley-error': errors.phone}"
                    autocomplete="off"
                    class="form-control"
                    id="phone"
                    :placeholder="$t('supplieruser.insert-phone')"
                    type="text"
                    v-model="user.phone">
                  <ul class="parsley-errors-list filled" v-if="errors.phone">
                    <li class="parsley-required">{{ errors.phone[0] }}</li>
                  </ul>
                </div>

                <div class="form-group">
                  <label for="position">{{ $t('supplieruser.position') }}</label>
                  <input
                    :class="{'parsley-error': errors.position}"
                    autocomplete="off"
                    class="form-control"
                    id="position"
                    :placeholder="$t('supplieruser.insert-position')"
                    type="text"
                    v-model="user.position">
                  <ul class="parsley-errors-list filled" v-if="errors.position">
                    <li class="parsley-required">{{ errors.position[0] }}</li>
                  </ul>
                </div>

                <div class="form-group">
                  <label for="position">{{ $t('supplieruser.role') }}</label>
                  <select v-model="user.role" class="custom-select custom-select-md mb-3">
                    <option disabled value="">{{ $t('supplieruser.role')}}</option>
                    <option value="PLAIN">{{$t('supplieruser.role-supplier')}}</option>
                    <option value="ADVANCED">{{$t('supplieruser.role-master')}}</option>
								  </select>
                  <ul class="parsley-errors-list filled" v-if="errors.role">
                    <li class="parsley-required">{{ errors.role[0] }}</li>
                  </ul>
                </div>

                <hr>

                <div class="row pb-3">
                  <div class="col-md-6">
                    <div class="checkbox c-checkbox">
                      <label for="is_active">
                        <input
                          v-model="user.is_active"
                          :class="{'parsley-error': errors.is_active}"
                          class="form-control"
                          type="checkbox"
                          id="is_active">
                        <span class="fa fa-check"></span>{{ $t('supplieruser.active') }}
                      </label>
                    </div>
                  </div>
                  <div class="col-md-6" v-if="!this.user.id">
                    <more/>
                  </div>
                </div>
                <div class="text-right">
                  <a @click="$router.go(-1)" class="btn btn-sm btn-secondary wd-xs" type="submit">
                    <span>{{ $t('supplieruser.cancel') }}</span>
                  </a>
                  <button class="btn btn-sm btn-success wd-xs" type="submit">{{ $t('supplieruser.save') }}</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import api from '@/api'
import message from '@/message'
import More from '@/components/More.vue'
import {objectToFormData, parseApiError} from '@/utils'
import Multiselect from 'vue-multiselect'

const getData = (sup, id, next) => {
  if (id) {
    Promise.all([
      api.get(`/supplier_users/${id}/`),
      api.get(`/suppliers/${sup}/`),
      api.get(`/groups/?is_active=true&page_size=100`)
    ])
      .then(([user, supplier, groups]) => {
        let group = []
        if (user.data.warehouse_groups) {
          user.data.warehouse_groups.forEach(wg => {
            group.push({
              'name': wg
            })
          })
        }

        next({
          user: user.data,
          supplier: supplier.data,
          warehouse_group: group,
          warehouse_groups: groups.data.results
        })
      })
  } else {
    Promise.all([
      api.get(`/suppliers/${sup}/`),
      api.get(`/groups/?is_active=true&page_size=100`)
    ])
      .then(([supplier, groups]) => {
        next({
          user: {
            first_name: '',
            last_name: '',
            email: '',
            personal_code: '',
            group: 'SUPPLIER',
            phone: '',
            position: '',
            is_active: true,
            is_admin: false,
          },
          supplier: supplier.data,
          warehouse_group: [],
          warehouse_groups: groups.data.results
        })
      })
  }
}

export default {
  components: {
    more: More,
    Multiselect
  },
  data () {
    return {
      user: {},
      supplier: {},
      warehouse_group: [],
      warehouse_groups: [],
      more: null,
      errors: {},
    }
  },
  computed: {
    is_supplier () {
      return this.$store.getters.user_group === 'Supplier'
    }
  },
  mounted () {
    this.$parent.menu = 'profile'
    this.$parent.submenu = ''
    this.$i18n.locale = this.$store.getters.language
  },
  methods: {
    save () {
      this.errors = {}

      let tagsGroups = []
      for (var n in this.warehouse_group) {
        tagsGroups.push(this.warehouse_group[n].name)
      }

      const data = objectToFormData({
        first_name: this.user.first_name,
        last_name: this.user.last_name,
        email: this.user.email,
        personal_code: this.user.personal_code,
        phone: this.user.phone,
        position: this.user.position,
        group: 'SUPPLIER',
        is_active: this.user.is_active,
        is_admin: false,
        supplier__id: this.supplier.id,
        supplier__name: this.supplier.name,
        supplier__registration_code: this.supplier.registration_code,
        warehouse_group: this.warehouse_group,
        warehouse_groups: tagsGroups,
        role: this.user.role
      })

      if (this.user.id) {
        api.patch(`/supplier_users/${this.user.id}/`, data)
          .then(() => {
            message.success(this.$i18n.t('supplieruser.updated'))
            this.$router.go(-1)
          })
          .catch(error => {
            let errors = parseApiError(error, this.$i18n)
            if (error.response && error.response.status === 400) {
              this.errors = errors
              if (!tagsGroups.length) {
                this.errors['warehouse_groups'] = [this.$i18n.t('one.group')]
              }
            } else {
              message.error(errors)
            }
          })
      } else {
        api.post('/supplier_users/', data)
          .then(() => {
            message.success(this.$i18n.t('supplieruser.added'))
            if (this.more) {
              this.user = {
                first_name: '',
                last_name: '',
                email: '',
                personal_code: '',
                phone: '',
                position: '',
                group: 'SUPPLIER',
                is_active: true,
                is_admin: false,
                role: '',
                warehouse_groups: []
              }
              this.warehouse_group = []
              this.warehouse_groups = []
              this.$router.push({name: 'supplier_users_add', params: {sup_id: this.supplier.id}})
            } else {
              this.$router.go(-1)
            }
          })
          .catch(error => {
            let errors = parseApiError(error, this.$i18n)
            if (error.response && error.response.status === 400) {
              this.errors = errors
              if (!tagsGroups.length) {
                this.errors['warehouse_groups'] = [this.$i18n.t('one.group')]
              }
            } else {
              message.error(errors)
            }
          })
      }
    },
    addGroup (newName) {
      this.warehouse_group.push({
        name: newName
      })
    }
  },
  beforeRouteEnter (to, from, next) {
    getData(to.params.sup_id, to.params.id, data => {
      next(vm => {
        Object.assign(vm.$data, data)
      })
    })
  },
  beforeRouteUpdate (to, from, next) {
    getData(to.params.sup_id, to.params.id, data => {
      Object.assign(this.$data, data)
      next()
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/views/Supplieruser.vue